<template>
  <div>
    <div class="content">
      <div class="title">添加优势亮点</div>
      <div class="cont">
        <div class="areaBox">
          <textarea
            v-model="content"
            placeholder="请输入主要优势亮点"
          ></textarea>
        </div>
      </div>
      <div class="tcBom">
        <div class="qbtn dis-cent">取消</div>
        <div class="btn dis-cent" @click="qrClick">确定</div>
      </div>
    </div>
    <XuanzeHy v-if="qwShow" @show="qwShowJs" :qwData="qwData" />
    <XuanzeZw v-if="zwShow" @show="zwShowJs" :zwData="zwData" />
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  DatePicker,
  LocaleProvider,
} from "ant-design-vue";
import XuanzeHy from "../component/xuanzeHy.vue";
import XuanzeZw from "../component/xuanzeZw.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"; // 引入中文语言包
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-range-picker": DatePicker.RangePicker,
    "a-month-picker": DatePicker.MonthPicker,
    "locale-provider": LocaleProvider,
    XuanzeHy,
    XuanzeZw,
  },
  name: "",
  data() {
    return {
      zhCN, // 使用中文语言包
      size: "default",
      qwShow: false,
      qwData: [],
      zwShow: false,
      zwData: [],
      addTxt: "请选择",
      qMoneyOn: null,
      qValue: undefined,
      qMoney: [],
      hValue: undefined,
      hMoney: [],
      yValue: undefined,
      yMoney: [],
      startMonth: null,
      endMonth: null,
      content: "",
    };
  },
  created() {},
  methods: {
    qrClick() {
      this.$emit("show");
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #f1f5fc;
  padding: 20px 50px;
  margin-top: 20px;
  margin-bottom: 10px;
  .title {
    font-size: 15px;
  }
  .cont {
    .areaBox {
      margin-bottom: 20px;
      border: 1px solid #d8d8d8;
      height: 200px;
      background-color: #fff;
      border-radius: 10px;
      margin-top: 15px;
      overflow: hidden;
      padding: 15px;
      box-sizing: border-box;
      textarea {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
  .tcBom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .btn {
      width: 90px;
      border-radius: 5px;
      height: 40px;
      background-color: #147ee0;
      color: #fff;
      cursor: pointer;
    }
    .qbtn {
      cursor: pointer;
      width: 90px;
      border-radius: 5px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #147ee0;
      color: #147ee0;
      margin-right: 20px;
    }
  }
}
</style>
